import type { EffectiveTheme } from "@/theme/themeContext";

export function applyThemeToRoot(effective: EffectiveTheme) {
  const root = document.documentElement;
  root.dataset.theme = effective;
  root.classList.toggle("dark", effective === "dark");
  root.style.colorScheme = effective;
}

let locked = false;
let lockedEffective: EffectiveTheme = "dark";

export function setDisplayThemeLock(effective: EffectiveTheme | null) {
  if (effective === null) {
    locked = false;
    return;
  }
  locked = true;
  lockedEffective = effective;
  applyThemeToRoot(effective);
}

export function isDisplayThemeLocked(): boolean {
  return locked;
}

export function getLockedDisplayTheme(): EffectiveTheme {
  return lockedEffective;
}

export const DISPLAY_THEME_UNLOCK = "eh-display-theme-unlock";
